import { z } from 'zod';
import { PAGINATION_ORDER } from '@core/constants/pagination.constant';

const orderSchema = z.enum([PAGINATION_ORDER.ASC, PAGINATION_ORDER.DESC]);

const paginationSchema = z.object({
  count: z.number(),
  limit: z.number(),
  order: orderSchema,
  offset: z.number()
});

export { orderSchema, paginationSchema };
